export class Clips {
    /**
     * @type {Element}
     */
    target = null;

    /**
     * @type {NodeListOf<HTMLDivElement>|null}
     */
    list = null;

    /**
     * @type {boolean}
     */
    isExpandable = false;

    /**
     * @type {boolean}
     */
    isSingleElement = false;

    /**
     * @type {boolean}
     */
    isAllClipsVisible = false;

    /**
     * @type {HTMLButtonElement|null}
     */
    buttonExpand = null;

    /**
     * @type {string}
     */
    classHidden = 'js-hidden';

    /**
     * @type {Object.<string, MediaQueryList>|null}
     */
    breakpoints = null;

    hasPrivacyOverlay = true;

    /**
     * @param {Element} target
     */
    constructor(target) {
        this.target = target;
        this.list = this.target.querySelectorAll('.entry');
        this.hasPrivacyOverlay = this.target.querySelector('.privacy-overlay');

        if (this.list.length === 0) {
            console.warn('avmplugins_clips: No clips found');
            return;
        }

        this.breakpoints = {
            desktop: window.matchMedia('(min-width: 986px)'),
            tablet: window.matchMedia('(max-width: 985px) and (min-width: 480px)'),
            smartphoneLandscape: window.matchMedia('(max-width: 767px) and (min-width: 480px)'),
            smartphonePortrait: window.matchMedia('(max-width: 479px)'),
        };

        this.isSingleElement = this.list.length === 1;
        this.isExpandable = this.target.classList.contains('tx-avmplugins-clips-expandable');
        this.isAllClipsVisible = !this.isExpandable;


        if (this.hasPrivacyOverlay) {
            this.target.addEventListener(
                'privacyoverlay:close',
                () => {
                    this.loadAllPreviewImages();
                },
                {
                    once: true
                }
            );
        } else {
            this.loadAllPreviewImages();
        }

        if (this.isExpandable) {
            this.buttonExpand = this.target.querySelector('.load-all-clips-wrapper button');

            this.handleButtonVisibility();
            this.handleItemVisibility();
        }

        this.setupEventHandler();
    }

    /**
     * Append event handler to buttons.
     *
     * @protected
     * @return void
     */
    setupEventHandler() {
        if (this.isExpandable) {
            Object.keys(this.breakpoints).forEach((key) => {
                this.breakpoints[key].addEventListener('change', () => {
                    this.handleButtonVisibility();
                    this.handleItemVisibility();
                });
            });

            this.buttonExpand.addEventListener('click', () => {
                this.handleExpandButtonClick();
            });
        }
    }

    /**
     * Load the preview image for a clip.
     *
     * @param {HTMLElement} element
     */
    loadPreviewImage(element) {
        /**
         * @type {HTMLImageElement|null}
         */
        const image = element.querySelector('img[data-src]');
        if (image === null) {
            return;
        }
        image.setAttribute('src', image.getAttribute('data-src'));
    }

    loadAllPreviewImages() {
        this.list.forEach((element) => {
            this.loadPreviewImage(element);
        });
    }

    handleExpandButtonClick() {
        this.list.forEach((element) => {
            element.classList.remove(this.classHidden);
        });
        this.isAllClipsVisible = true;
        this.hideExpandButton();
    }

    handleButtonVisibility() {
        if (this.isAllClipsVisible) {
            this.hideExpandButton();
            return;
        }

        if (
            (this.breakpoints.desktop.matches && this.list.length <= 3) ||
            (this.breakpoints.tablet.matches && this.list.length <= 2) ||
            (
                (
                    this.breakpoints.smartphoneLandscape.matches ||
                    this.breakpoints.smartphonePortrait.matches
                ) &&
                this.list.length <= 1
            )
        ) {
            this.hideExpandButton();
        } else {
            this.showExpandButton();
        }
    }

    handleItemVisibility() {
        if (this.isAllClipsVisible) {
            return;
        }

        /**
         * @type {NodeListOf<HTMLElement>}
         */
        let visibleEntries = this.target.querySelectorAll('.entry:nth-child(-n+3)');

        if (this.breakpoints.tablet.matches) {
            visibleEntries = this.target.querySelectorAll('.entry:nth-child(-n+2)');
        }

        if (
            this.breakpoints.smartphoneLandscape.matches ||
            this.breakpoints.smartphonePortrait.matches
        ) {
            visibleEntries = this.target.querySelectorAll('.entry:nth-child(-n+1)');
        }

        this.list.forEach(
            /**
             * @param {HTMLElement} element
             */
            (element) => {
                if (!Array.from(visibleEntries).includes(element)) {
                    element.classList.add(this.classHidden);
                }
            }
        );

        visibleEntries.forEach((element) => {
            element.classList.remove(this.classHidden);
        });
    }

    hideExpandButton() {
        this.buttonExpand.classList.add(this.classHidden);
    }

    showExpandButton() {
        this.buttonExpand.classList.remove(this.classHidden);
    }
}
